module.exports = __webpack_public_path__ + "static/media/react-logo-transparent.f7d45c01.svg";